import { render, staticRenderFns } from "./EpicInbasketMessage.vue?vue&type=template&id=9d1518be&scoped=true&"
import script from "./EpicInbasketMessage.vue?vue&type=script&lang=js&"
export * from "./EpicInbasketMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1518be",
  null
  
)

export default component.exports